// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__pPV-s","hero_image":"Hero_hero_image__dx5Nw","hero_background":"Hero_hero_background__HClk5","hero_title":"Hero_hero_title__bCVW0"};